'use client';

import { useEffect, useState } from 'react';
import { ClientDate } from '../ClientDate';
import type { AuditEntry } from '../types';

export function AuditPanel() {
  const [rows, setRows] = useState<AuditEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/super-admin/audit?limit=100')
      .then((r) => r.json())
      .then((j) => setRows(j.data ?? []))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-sm text-ink-500">A carregar auditoria...</p>;

  return (
    <section className="sa-card">
      <header className="sa-card-header">
        <h3 className="sa-card-title">Registo de auditoria</h3>
        <p className="sa-card-desc">Acoes de super-admin na plataforma</p>
      </header>
      {rows.length === 0 ? (
        <p className="text-sm text-ink-500">Sem eventos (executa migracao 013 se necessario).</p>
      ) : (
        <div className="sa-table-wrap">
          <table className="sa-table">
            <thead>
              <tr>
                <th>Quando</th>
                <th>Quem</th>
                <th>Acao</th>
                <th>Tenant</th>
                <th>Detalhes</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td className="text-xs whitespace-nowrap"><ClientDate value={r.created_at} /></td>
                  <td className="text-xs font-mono">{r.actor_email}</td>
                  <td><span className="sa-tag">{r.action}</span></td>
                  <td className="text-sm">{r.tenant_name ?? '—'}</td>
                  <td className="text-xs text-ink-500 max-w-xs truncate">
                    {JSON.stringify(r.details ?? {})}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
